// @flow

//
// FP
//
import * as $ from 'sanctuary-def';
import S from '../../../../../lib/trix-fp-fantasy';

//
// React
//
import React, { useState } from 'react';

//
// Material UI
//
import {
  Typography,
  Button,
  Box,
  Avatar,
} from '@mui/material';

//
// Hal forms
//
import {
    getActionFactory,
	getSelector,
} from '../../../../../lib/trix-web-hal-forms/tools/halFormsRedux';
//
// Redux Fantasy
//
import {
    useLocalSelector,
    useDispatchLocal,
} from '../../../../../lib/redux-fantasy-reducers';

//
// Trix Middleware
//
import { postFormData } from '../../../../../lib/trix-web-middleware-commons';

//
// Props
//
type Props = {
    //
    // Data
    //
    data: any,

    //
    // Error
    //
    error: any,

    // PATCH:
    __ducks: any,

    //
    // Actions
    //
    onChange: (value: any, meta: any) => any,
    onClose: () => void,
};

//
// Component
//
const UploadImageForm = (props: Props) => {
    //
    // Hooks
    //
    const dispatchLocal = useDispatchLocal();

    const [selectedImage, setSelectedImage] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [uploading, setUploading] = useState(false);

    // End hooks

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleUpload = () => {
        if (!selectedImage) {
            alert('Моля, изберете изображение!');
            return;
        }

        const formData = new FormData();
        formData.append('image', selectedImage);

        setUploading(true);
        postFormData(
            props.data._links.uploadImage.href, 
            formData,
            (error) => { 
                alert("Грешка при качване на изображение!");
                setUploading(false);
            },
            (body) => { 
                console.log('RESOLVE:', body); 
                setUploading(false);
                
                // PATCH: mess inside hal forms interns. Have to make hal forms interface to that!
                const setDataActionFactoryMaybe = getActionFactory 
                        (props.__ducks) 
                        ('trix-web-plugin-core-product.manageProductPage.container') 
                        ('data.setData');
                if (S.isJust (setDataActionFactoryMaybe)) {
                    const f = S.maybeToNullable(setDataActionFactoryMaybe);
                    if (f) {
                        const action = f (body.body);
                        dispatchLocal(action);
                    } else {
                        console.error('Invalid setData action');
                    }
                }

                props.onClose();
            },
        );
    };

    return (                
        <div>
            <Box display='flex' flexDirection='column' gap={2}>
                <Button variant='outlined' component='label' disabled={uploading}>
                    Изберете изображение
                    <input
                        type='file'
                        accept='image/*'
                        hidden
                        onChange={handleImageChange}
                    />
                </Button>

                {previewUrl && (
                    <Box textAlign='center' mt={2}>
                        <Avatar
                            src={previewUrl}
                            alt='Preview'
                            sx={{
                                width: 200,
                                height: 200,
                                mx: 'auto',
                                borderRadius: 2,
                                border: '1px solid #ccc',
                            }}
                            variant='square'
                        />
                        <Typography variant='body2' mt={1}>
                            {selectedImage?.name}
                        </Typography>
                    </Box>
                )}

                <Button
                    type='submit'
                    variant='contained'
                    color='primary'
                    disabled={!selectedImage || uploading}
                    onClick={() => { handleUpload(); }}
                >
                    {uploading ? 'Качване...' : 'Качи'}
                </Button>
            </Box>
        </div>
    );
};
export default UploadImageForm;
